import script from "./PatientAvailability.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientAvailability.vue?vue&type=script&setup=true&lang=ts"

import "./PatientAvailability.vue?vue&type=style&index=0&id=6e059420&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e059420"]])

export default __exports__